import React from "react";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";

const ApexChart = ({ options, series, error }) => {
    return (
        <div id="chart" className="d-block w-100 h-100 position-relative">
            {error ? (
                <div
                    className="position-absolute top-0 left-0 flex flex-col h-100 w-100 justify-content-center align-items-center"
                    style={{
                        backgroundColor: "rgba(255,255,255,0.6)",
                        zIndex: 1,
                    }}
                >
                    {error}
                </div>
            ) : null}
            <ReactApexChart
                options={options}
                series={series}
                type="line"
                height={350}
            />
        </div>
    );
};

export default ApexChart;
